<!-- Компактный маршрут титула без вычисления состояния перевозки. -->
<template>
  <div v-if="points.length" class="edo-title-route">
    <div class="edo-title-route__rail" aria-hidden="true">
      <template v-for="(point, index) in points" :key="point.key || index">
        <span
          class="edo-title-route__marker"
          :class="{ 'edo-title-route__marker--last': index === points.length - 1 }"
        ></span>
        <span
          v-if="index < points.length - 1"
          class="edo-title-route__line"
        ></span>
      </template>
    </div>

    <div class="edo-title-route__points">
      <div
        v-for="(point, index) in points"
        :key="point.key || index"
        class="edo-title-route__point"
      >
        <span class="edo-title-route__label">{{ point.label }}</span>
        <span class="edo-title-route__value">{{ point.value || "—" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EdoDocumentRouteTimeline",

  props: {
    points: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.edo-title-route {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.edo-title-route__rail {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: none;
  padding-top: 4px;
}

.edo-title-route__marker {
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 3px solid var(--color-dark);
  border-radius: 50%;
  background: #fff;
}

.edo-title-route__marker--last {
  background: var(--color-dark);
}

.edo-title-route__line {
  flex: 1;
  width: 2px;
  min-height: 12px;
  margin: 4px 0;
  background: #d5d9e4;
}

.edo-title-route__points {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.edo-title-route__point {
  display: grid;
  gap: 2px;
}

.edo-title-route__label {
  color: #5b6070;
  font-size: 13px;
  line-height: 18px;
}

.edo-title-route__value {
  color: var(--color-dark);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  overflow-wrap: anywhere;
}
</style>
